import { useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
// import DashboardIcon from "@material-ui/icons/Dashboard";
import {
  getResources,
  MenuItemLink,
} from "react-admin";
import { arrayUniqueById, hasCurrentUserPermissionByName } from "../utils/utils";
import SubMenu from "./SubMenu";
import { MenuIsOpenState } from "../constants/menuCategories";

const Menu = ({ onMenuClick, logout, dense }) => {
  const [state, setState] = useState(MenuIsOpenState);
  const open = useSelector((state) => state.admin.ui.sidebarOpen);
  const resources = useSelector(getResources);
  const resourcesWithPermission = [];
  resources.forEach(item => {
    if (item.options.permissions) {
      let cont = true;
      item.options.permissions.forEach(el => {
        if (hasCurrentUserPermissionByName(el) && cont) {
          resourcesWithPermission.push(item);
          cont = false;
        }
      });
    }
    // if (hasCurrentUserPermissionByName(item.options.permission)) {
    //   resourcesWithPermission.push(item);
    // }
  });

  let categories = resourcesWithPermission.map(item => item.options.category);
  categories = arrayUniqueById(categories);
  const handleIsOpenMenuToggle = (menu) => {
    setState((state) => ({ ...state, [menu]: !state[menu] }));
  };


  return (
    <div>
      {/* <MenuItemLink
        key={"dashboard"}
        to="/#"
        primaryText={"داشبورد"}
        leftIcon={<DashboardIcon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      /> */}
      <br></br>
      <br></br>

      {categories.map(category => {
        const categoryResources = resourcesWithPermission.filter(item => item.options.category.id === category.id);
        if (categoryResources.length === 1) {
          return <div style={{ marginRight: "12px" }}>
            {categoryResources.map(resource => (
              <MenuItemLink
                key={resource.name}
                to={`/${resource.name}`}
                primaryText={resource.options.label}
                leftIcon={resource.icon}
                resource={resource.name}
                onClick={onMenuClick}
                sidebarIsOpen={open}
              />
            ))}
          </div>
        } else {

          return <SubMenu
            handleToggle={() => handleIsOpenMenuToggle(category.id)}
            key={category.id}
            isOpen={state[category.id]}
            sidebarIsOpen={open}
            name={category.name}
            dense={dense}
            icon={category.icon}
          >

            {categoryResources.map(resource => (
              <MenuItemLink
                key={resource.name}
                to={`/${resource.name}`}
                primaryText={resource.options.label}
                leftIcon={resource.icon}
                onClick={onMenuClick}
                resource={resource.name}
                sidebarIsOpen={open}
              />
            ))}
          </SubMenu>;
        }
      })}
      {/* <div style={{ position: 'absolute', bottom: '4%', right: '4%' }}>
        {logout}
      </div> */}
    </div>
  );
}

Menu.propTypes = {
  onMenuClick: PropTypes.func,
  logout: PropTypes.object,
};

export default Menu;
